import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSouth = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 21.575C11.8667 21.575 11.7417 21.554 11.625 21.512C11.5083 21.4707 11.4 21.4 11.3 21.3L5.7 15.7C5.51667 15.5167 5.425 15.2873 5.425 15.012C5.425 14.7373 5.51667 14.5 5.7 14.3C5.9 14.1 6.13734 14 6.412 14C6.68734 14 6.925 14.1 7.125 14.3L11 18.175V3C11 2.71667 11.096 2.479 11.288 2.287C11.4793 2.09567 11.7167 2 12 2C12.2833 2 12.521 2.09567 12.713 2.287C12.9043 2.479 13 2.71667 13 3V18.175L16.9 14.3C17.0833 14.1167 17.3123 14.0207 17.587 14.012C17.8623 14.004 18.1 14.1 18.3 14.3C18.4833 14.4833 18.575 14.7167 18.575 15C18.575 15.2833 18.4833 15.5167 18.3 15.7L12.7 21.3C12.6 21.4 12.4917 21.4707 12.375 21.512C12.2583 21.554 12.1333 21.575 12 21.575Z",
		fill: "currentColor"
	})
});
export default SvgSouth;
